import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import ThemeDialog from "@/components/management/theme/ThemeDialog";
import { getSubjectList, getSubjectInfo, handleSubjectDelete } from "@/api/managementCenter/themeManage";
import { getRegisterUserPage, setRegisterStatus } from "@/api/admin/user";
export default {
  name: "thirdPartyManagement",
  components: {
    Sift: Sift,
    ThemeDialog: ThemeDialog
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      siftData: [{
        type: "text",
        key: "keyWord",
        label: "关键字查询",
        placeholder: "请输入关键字",
        default: ""
      }, {
        type: "select",
        key: "status",
        label: "审核状态",
        placeholder: "请选择审核状态",
        default: "",
        data: [{
          label: "通过",
          value: "1"
        }, {
          label: "驳回",
          value: "2"
        }]
      }],
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10
      },
      total: 0
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
  },
  methods: {
    // 获取查询列表
    getListFn: function getListFn() {
      var _this = this;

      this.loading = true;
      getRegisterUserPage(this.paramSearch).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.list = data.data.records || [];
          _this.total = data.data.total;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 删除
    deleteFn: function deleteFn(id, name) {
      var _this2 = this;

      this.$confirm("是否确定删除" + name + " ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {}).catch(function () {
        _this2.$message.info("已取消删除");
      });
    },
    //审核
    setStatus: function setStatus(id, status) {
      var _this3 = this;

      var params = {
        id: id,
        status: status
      };
      setRegisterStatus(params).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == "0") {
          _this3.getListFn();

          _this3.$message.success("操作成功!");
        } else {
          _this3.$message.warning(data.msg || "操作失败！");
        }
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.paramSearch = _objectSpread(_objectSpread(_objectSpread({}, this.paramSearch), this.$refs.needSift.getValue()), {}, {
        current: 1
      });
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    saveSuccess: function saveSuccess() {
      this.getListFn();
    }
  },
  watch: {},
  filters: {}
};